import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { QUOTE_STATUS_OPTIONS } from "@/lib/quote-status";

interface QuoteStatusControlProps {
  status: string;
  onChange: (status: string) => void;
  disabled?: boolean;
}

export function QuoteStatusControl({
  status,
  onChange,
  disabled = false,
}: QuoteStatusControlProps) {
  return (
    <div>
      <Select value={status} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          className="h-8 w-[132px] text-xs"
          aria-label="Quote status"
          data-testid="select-quote-status"
        >
          <SelectValue placeholder="Select status" />
        </SelectTrigger>
        <SelectContent>
          {QUOTE_STATUS_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}